export * from "./wsWebScraping";
export * from "./wsSpa";
export * from "./wsTerceiros";
export * from "./funcoes";
export * from "./wsGam";
